import { useAuth } from '@stuller/stullercom/feat/auth'
import { Button } from '@stuller/stullercom/ui'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { type ReactElement } from 'react'

/**
 * Displays information about new account signup and a button/link to "Login for Pricing"
 */
function LoginForPricing (): ReactElement | null {
  const { authUser } = useAuth()
  const { asPath } = useRouter()

  if (authUser?.user != null) {
    return null
  }

  return (
    <div className='d-flex flex-column'>
      <p>Stuller only sells to students and professionals in the jewelry trade. <Link href='/accountsignup' passHref aria-label=''>Apply for a resale account</Link> to access all of Stuller's products, benefits, and services.</p>
      <Button pill color='primary' tag='a' href={`/login?returnUrl=${encodeURIComponent(asPath)}`} aria-label='Login button'>Log in for Pricing</Button>
    </div>
  )
}

export {
  LoginForPricing
}
